<template>
  <!-- 单个添加设备组件 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="60%"
      :mask-closable="false"
      :footer-hide="true"
      :title="deviceType === 0 ? $t('deviceSip.add') : $t('deviceSip.edit')"
      class-name="vertical-center-modal"
    >
      <Spin v-if="spinShow" size="large" fix></Spin>
      <div ref="addDevice" class="modalHeight adddevice-box">
        <!-- 基本信息配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.baseConfig") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="addForm"
              :label-width="200"
              :model="addForm"
              label-colon
              :rules="ruleValidateBaseDevice"
            >
              <!-- 设备名称 -->
              <FormItem prop="name" :label="$t('deviceSip.deviceName')">
                <Input
                  v-model="addForm.name"
                  size="large"
                  :placeholder="$t('updateNewSip.deviceNameTip')"
                  clearable
                  maxlength="16"
                />
              </FormItem>
              <!-- 设备支持功能 -->
              <FormItem prop="funList" :label="$t('deviceSip.function')">
                <RadioGroup
                  v-model="addForm.productType"
                  @on-change="setFunList"
                >
                  <Radio
                    v-for="item in allDevList"
                    :key="item.value"
                    :label="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
                <!-- 选择其他的设备类型，需要带出设备类型的选项 -->
                <Row
                  v-if="Number(addForm.productType) == 0"
                  gutter="20"
                  class="margin-box"
                >
                  <i-col span="24">
                    <Select
                      v-model="addForm.deviceType"
                      size="large"
                      :placeholder="$t('newDeviceType.deviceTypeTip')"
                    >
                      <Option
                        v-for="item in deviceTypeList"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </Option>
                    </Select>
                  </i-col>
                </Row>

                <Row gutter="20">
                  <i-col span="16">
                    <CheckboxGroup v-model="addForm.funList">
                      <Checkbox
                        v-for="item in allFunList"
                        :key="item.value"
                        :label="item.value"
                        :disabled="
                          Number(addForm.productType) == 0 ? false : true
                        "
                      >
                        <span>{{ item.label }}</span>
                      </Checkbox>
                    </CheckboxGroup>
                  </i-col>
                  <i-col span="2">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("updateNewSip.funTitle") }}</h4>
                        <h4>
                          "{{ $t("updateNewSip.callin") }}":&nbsp;
                          {{ $t("updateNewSip.callInTip") }}
                        </h4>
                        <h4>
                          "{{ $t("updateNewSip.callout") }}":&nbsp;
                          {{ $t("updateNewSip.callOutTip") }}
                        </h4>
                        <h4>
                          "{{ $t("deviceSip.monitor") }}":&nbsp;
                          {{ $t("updateNewSip.monitorTip") }}
                        </h4>
                        <h4>
                          "{{ $t("updateNewSip.doorAuth") }}":&nbsp;
                          {{ $t("updateNewSip.doorTip") }}
                        </h4>
                        <h4>
                          "{{ $t("deviceSip.lift") }}":&nbsp;
                          {{ $t("updateNewSip.liftTip") }}
                        </h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- 网络配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.net") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="netForm"
              :label-width="200"
              :model="netForm"
              label-colon
              :rules="ruleValidateNet1"
            >
              <!-- 网络类型 -->
              <FormItem prop="mode" :label="$t('deviceSip.netType')">
                <Row>
                  <i-col span="8">
                    <!-- DHCP时，ip、mask、gateway、dns等不显示，为默认配置 -->
                    <RadioGroup v-model="netForm.mode">
                      <Radio :label="1">
                        <span>Static</span>
                      </Radio>
                      <!-- 无dhcp选项 -->
                    </RadioGroup>
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip trigger="hover" :title="$t('deviceSip.note')">
                      <template #content>
                        <h4>{{ $t("deviceSip.netTip1") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新输入子网掩码 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="mask"
                :label="$t('deviceSip.mask')"
              >
                <Input
                  v-model="netForm.mask"
                  size="large"
                  :placeholder="$t('updateNewSip.maskTip')"
                  clearable
                  @on-blur="validateIpAndMask()"
                />
              </FormItem>
              <!-- 请重新输入网关 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="gateway"
                :label="$t('deviceSip.gateway')"
              >
                <Input
                  v-model="netForm.gateway"
                  size="large"
                  :placeholder="$t('updateNewSip.gatewayTip')"
                  clearable
                />
              </FormItem>
              <!-- 请重新输入IP地址 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="ip"
                :label="$t('deviceSip.ip')"
              >
                <Row>
                  <i-col span="24">
                    <Input
                      v-model="netForm.ip"
                      size="large"
                      :placeholder="$t('updateNewSip.ip1')"
                      clearable
                      @on-blur="validateIpAndMask()"
                    />
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新输入DNS1 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="dns1"
                :label="$t('deviceSip.dns1')"
              >
                <Input
                  v-model="netForm.dns1"
                  size="large"
                  :placeholder="$t('updateNewSip.dns1')"
                  clearable
                />
              </FormItem>
              <!-- 请重新输入DNS2 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="dns2"
                :label="$t('deviceSip.dns2')"
              >
                <Input
                  v-model="netForm.dns2"
                  size="large"
                  :placeholder="$t('updateNewSip.dns2')"
                  clearable
                />
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- sip1信息配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.sip1") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="sipForm1"
              :label-width="200"
              :model="sipForm1"
              label-colon
              :rules="
                sipForm1.mode === 1 ? ruleValidateSip1_1 : ruleValidateSip1_2
              "
            >
              <!-- SIP模式 -->
              <FormItem prop="mode" :label="$t('deviceSip.mode')">
                <RadioGroup v-model="sipForm1.mode">
                  <Radio :label="1">
                    <span>{{ $t("deviceSip.mode1") }}</span>
                  </Radio>
                  <Radio :label="2">
                    <span>{{ $t("deviceSip.mode2") }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <!-- 请重新输入用户名 -->
              <FormItem prop="account" :label="$t('deviceSip.user')">
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm1.account"
                      size="large"
                      :placeholder="$t('deviceSip.user')"
                      clearable
                      maxlength="60"
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.sipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 密码 -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="password"
                :label="$t('deviceSip.password')"
              >
                <Input
                  v-model="sipForm1.password"
                  size="large"
                  :placeholder="$t('deviceSip.password')"
                  clearable
                  :maxlength="32"
                />
              </FormItem>
              <!--  请重新输入serverIP -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="serviceIp"
                :label="$t('deviceSip.serverIp')"
              >
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm1.serviceIp"
                      size="large"
                      :placeholder="$t('updateNewSip.serverIp')"
                      clearable
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.ipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新选择协议类型 -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="protocolType"
                :label="$t('deviceSip.protocolType')"
              >
                <RadioGroup v-model="sipForm1.protocolType">
                  <Radio :label="1">
                    <span>UDP</span>
                  </Radio>
                  <Radio :label="2">
                    <span>TCP</span>
                  </Radio>
                  <Radio :label="3">
                    <span>TLS</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- sip2信息配置--更多展示 -->
        <Row v-if="!isExpandSip2" class="margin-bottom-20">
          <i-col span="3" class="text-center">
            <h4>{{ $t("deviceSip.sip2") }}</h4>
          </i-col>
          <i-col span="17" offset="1">
            <hr class="more-hr" />
          </i-col>
          <i-col span="2" offset="1" class="more-box">
            <span class="area-box more-text" @click="expandMore">{{
              $t("deviceSip.more")
            }}</span>
            <span class="more-img" @click="expandMore"></span>
          </i-col>
        </Row>
        <!--sip2信息配置  -->
        <Row v-else class="margin-bottom-20 relative-box">
          <i-col span="2" offset="1" class="more-box position-box">
            <span class="area-box more-text" @click="expandMore">{{
              $t("deviceSip.close")
            }}</span>
            <span class="more-img tranform-box" @click="expandMore"></span>
          </i-col>
          <i-col span="3" class="text-center">
            <h4>{{ $t("deviceSip.sip2") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="sipForm2"
              :label-width="200"
              :model="sipForm2"
              label-colon
              :rules="
                sipForm2.mode === 1 ? ruleValidateSip2_1 : ruleValidateSip2_2
              "
            >
              <!-- SIP模式 -->
              <FormItem prop="mode" :label="$t('deviceSip.mode')">
                <RadioGroup v-model="sipForm2.mode">
                  <Radio :label="1">
                    <span>{{ $t("deviceSip.mode1") }}</span>
                  </Radio>
                  <Radio :label="2">
                    <span>{{ $t("deviceSip.mode2") }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <!-- 请重新输入用户名 -->
              <FormItem prop="account" :label="$t('deviceSip.user')">
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm2.account"
                      size="large"
                      :placeholder="$t('deviceSip.user')"
                      clearable
                      maxlength="60"
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.sipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 密码 -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="password"
                :label="$t('deviceSip.password')"
              >
                <Input
                  v-model="sipForm2.password"
                  size="large"
                  :placeholder="$t('deviceSip.password')"
                  clearable
                  :maxlength="32"
                />
              </FormItem>
              <!--  请重新输入serverIP -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="serviceIp"
                :label="$t('deviceSip.serverIp')"
              >
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm2.serviceIp"
                      size="large"
                      :placeholder="$t('updateNewSip.serverIp')"
                      clearable
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.ipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新选择协议类型 -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="protocolType"
                :label="$t('deviceSip.protocolType')"
              >
                <RadioGroup v-model="sipForm2.protocolType">
                  <Radio :label="1">
                    <span>UDP</span>
                  </Radio>
                  <Radio :label="2">
                    <span>TCP</span>
                  </Radio>
                  <Radio :label="3">
                    <span>TLS</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Form>
          </i-col>
        </Row>
      </div>
      <!-- 底部按钮 -->
      <div class="detailBackBtn">
        <Button size="large" @click="closeModal">{{
          $t("common.cancel")
        }}</Button>
        <Button type="primary" size="large" @click="handleSubmit">{{
          $t("common.ensure")
        }}</Button>
      </div>
    </Modal>
    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal
        ref="resultModal"
        :type="modalType"
        @afterComfirm="closeModal"
      ></modal>
    </div>
  </div>
</template>

<script>
import { checkIPAndSubnet } from "@/utils/validateIP.js";
import { mapState } from "vuex";
export default {
  name: "addDeviceModal",
  props: {
    isBatchDevice: {
      type: Boolean,
      default: false,
    },
    deviceType: {
      // 设备modal的操作类型 ：0新增，1编辑
      type: Number,
      default: 0,
    },
    currentNode: {
      // 左侧树选中的节点信息
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      spinShow: false,
      isExpandSip2: false,
      dialogVisible: false,
      addForm: {
        name: "",
        funList: [0, 1, 3],
        deviceType: 1, //
        productType: "SI701",
      }, // 设备表单
      productType: 1,
      netForm: {
        mode: 1,
        ip: "",
        gateway: "",
        mask: "",
        dns1: "",
        dns2: "",
      }, // 网络配置表单
      sipForm1: {
        account: "",
        mode: 1,
        password: "",
        protocolType: 1,
        serviceIp: "",
      }, // sip1配置表单
      sipForm2: {
        account: "",
        mode: 1,
        password: "",
        protocolType: 1,
        serviceIp: "",
      }, // sip2配置表单
      modalType: false,
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "deviceTypeList",
      "areaData",
      "areaDeviceData",
      "allFunList",
      "allDevList",
      "ruleValidateBaseDevice",
      "ruleValidateNet1",
      "ruleValidateSip1_1",
      "ruleValidateSip1_2",
      "ruleValidateSip2_1",
      "ruleValidateSip2_2",
      "allDeviceNum",
    ]),
    ...mapState("common", ["notAllZoneIpReg"]),
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible === false) {
          this.$refs.addDevice.scrollTop = 0; // 始终在最顶层
          this.addForm.deviceType = 1;
          this.addForm.productType = "SI701";
          this.$refs.addForm.resetFields();
          this.$refs["netForm"].resetFields();
          this.$refs["sipForm1"].resetFields();

          if (this.$refs.sipForm2) {
            this.$refs["sipForm2"].resetFields();
          }
          this.isExpandSip2 = false;
          // 弹窗关闭 清空数据
        } else {
          // 编辑设备
          if (Number(this.deviceType) === 1) {
            console.log(this.currentNode);

            // 判断是设备节点还是区域节点
            if (
              this.currentNode.funList &&
              this.currentNode.funList.length > 0
            ) {
              this.addForm.name = this.currentNode.name;
              this.addForm.funList = this.currentNode.funList;

              this.netForm = JSON.parse(
                JSON.stringify(this.currentNode.netInfoDTO)
              );
              this.sipForm1 = JSON.parse(
                JSON.stringify(this.currentNode.sipInfoDTOList[0])
              );

              if (this.currentNode.sipInfoDTOList.length === 2) {
                this.sipForm2 = JSON.parse(
                  JSON.stringify(this.currentNode.sipInfoDTOList[1])
                );
                this.isExpandSip2 = true;
              }
            }

            this.addForm.deviceType = Number(this.currentNode.deviceType);
            this.addForm.productType = this.currentNode.productType;
          }
        }
      },
    },
  },
  methods: {
    // 校验ip的正确性，ip&mask  相对段二进制&
    validateIpAndMask() {
      const { mask, ip } = this.netForm;
      if (ip.length > 0 && mask.length === 0) {
        if (!this.notAllZoneIpReg.test(mask)) {
          this.$Message.error(this.$t("updateNewSip.correctMaskTip"));
          return;
        }
      }

      if (ip.length > 0 && mask.length > 0) {
        if (!this.notAllZoneIpReg.test(ip)) {
          this.$Message.error(this.$t("updateNewSip.correctIpTip"));
          return;
        }
      }

      // 检查 IP 地址与子网掩码按位与的结果是否全为 0 或全为 1
      let isCorrectResult = checkIPAndSubnet(ip, mask);

      if (isCorrectResult) {
        this.$Message.error(this.$t("updateNewSip.ipAndMaskTip3"));
        this.netForm.ip = "";
        return;
      }
    },
    // 展示更多
    expandMore() {
      this.isExpandSip2 = !this.isExpandSip2;
    },
    closeModal() {
      this.dialogVisible = false;
    },
    // 提交方法
    handleSubmit() {
      this.spinShow = true;
      let that = this;
      let addForm = new Promise((resolve, reject) => {
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("addForm");
          }
        });
      });
      let netForm = new Promise((resolve, reject) => {
        this.$refs["netForm"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("netForm");
          }
        });
      });
      let sipForm1 = new Promise((resolve, reject) => {
        this.$refs["sipForm1"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("sipForm1");
          }
        });
      });
      let sipForm2 = new Promise((resolve, reject) => {
        if (this.isExpandSip2) {
          this.$refs.sipForm2.validate((valid) => {
            console.log(2);
            if (!valid) {
              if (
                this.sipForm2.account.length > 0 ||
                this.sipForm2.password.length > 0 ||
                this.sipForm2.serviceIp.length > 0
              ) {
                this.$Message.error(this.$t("deviceSip.sip2Tip"));
                reject("sipForm2");
              }
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      // 异步表单校验
      Promise.all([addForm, netForm, sipForm1, sipForm2])
        .then((res) => {
          // 验证成功 向提交数据
          that.changeDevice();
        })
        .catch((err) => {
          this.spinShow = false;
          console.log(err);
        });
    },
    // 判断区域下的设备最大值：8
    checkDeviceNum(
      node,
      maxNum = this.$store.state.projectConfig.DEVICE_NUM_MAX
    ) {
      if (this.deviceType === 1) {
        return true;
      }
      let groupList = node.groupList;
      let deviceList = groupList.filter(
        (item) => item.funList && item.funList.length > 0
      );

      if (deviceList.length >= maxNum) {
        this.$Message.error(this.$t("deviceSip.maxTip1"));
        return false;
      } else {
        return true;
      }
    },
    changeDevice() {
      // 设备上限判断
      if (!this.checkAllDeviceNum()) {
        this.spinShow = false;
        return;
      }
      // 树形结构已显示最外层设备
      if (this.currentNode.isTopDevice) {
        // 区域下的设备
        this.setDeepArrData(
          this.areaDeviceData,
          this.currentNode["$treeNodeId"],
          "$treeNodeId",
          "groupList",
          "name"
        );
        this.$store.commit(
          "projectConfig/SET_AREADEVICEDATA",
          this.areaDeviceData
        );
        return;
      } else {
        // 判断是区域节点还是
        if (this.currentNode.code) {
          // 判断设备上限数量
          let isAllow = this.checkDeviceNum(this.currentNode);
          if (!isAllow) {
            this.spinShow = false;
            return;
          }

          // 区域下的设备
          this.setDeepArrData(
            this.areaDeviceData,
            this.currentNode["$treeNodeId"],
            "$treeNodeId",
            "groupList",
            "name"
          );
          this.$store.commit(
            "projectConfig/SET_AREADEVICEDATA",
            this.areaDeviceData
          );
          return;
        }

        if (this.currentNode.funList && this.currentNode.funList.length === 0) {
          // 判断当前是否有设备列表
          let hasTopDeviceList = this.areaDeviceData.filter(
            (item) => item.isTopDevice
          );
          let noTopDeviceList = this.areaDeviceData.filter(
            (item) => !item.isTopDevice
          );
          // 最外层设备
          let deviceObj = {
            deviceType: this.addForm.deviceType,
            productType: this.addForm.productType,
            funList: this.addForm.funList,
            name: this.addForm.name,
            namePath: this.addForm.name,
            netInfoDTO: JSON.parse(JSON.stringify(this.netForm)),
            sipInfoDTOList: this.putSipForm2(), // sip1与sip2的配置关系
          };

          if (hasTopDeviceList.length > 0) {
            hasTopDeviceList[0].groupList.push(deviceObj);
            // 区域、设备名称排序  按字符串排序
            hasTopDeviceList[0].groupList = hasTopDeviceList[0].groupList.sort(
              (a, b) => {
                return a.name.localeCompare(b.name);
              }
            );
            this.areaDeviceData = hasTopDeviceList.concat(noTopDeviceList);
          } else {
            // 最外层节点
            let nodeObj = {
              name: this.$t("deviceSip.list"),
              title: this.$t("deviceSip.list"),
              isTopDevice: true,
              children: [],
              groupList: [],
              expand: true,
              level: 1, // 第一层级
            };
            nodeObj.groupList.push(deviceObj);
            // 区域、设备名称排序  按字符串排序
            nodeObj.groupList = nodeObj.groupList.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            this.areaDeviceData.unshift(nodeObj);
          }
          // 添加成功，关闭弹窗
          this.spinShow = false;
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
        } else {
          let isAllow = this.checkDeviceNum(this.currentNode);
          if (!isAllow) {
            this.spinShow = false;
            return;
          }
          this.setDeepArrData(
            this.areaDeviceData,
            this.currentNode["$treeNodeId"],
            "$treeNodeId",
            "groupList",
            "name"
          );
          this.$store.commit(
            "projectConfig/SET_AREADEVICEDATA",
            this.areaDeviceData
          );
          return;
        }
      }

      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );
      this.$emit("updateTree");
    },
    // 递归查找当前选中的区域节点，新增设备或修改当前选中的设备
    setDeepArrData(
      arr,
      id,
      idStr = "$treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (item[idStr] === id) {
          // 遍历
          let deviceObj = {
            deviceType: this.addForm.deviceType,
            productType: this.addForm.productType,
            funList: this.addForm.funList,
            name: this.addForm.name,
            netInfoDTO: JSON.parse(JSON.stringify(this.netForm)),
            sipInfoDTOList: this.putSipForm2(),
          };
          deviceObj = JSON.parse(JSON.stringify(deviceObj));

          if (this.deviceType === 0) {
            // 新增
            if (!item.groupList) {
              item.groupList = [];
            }

            if (Array.isArray(item[child])) {
              // 树形显示
              item.groupList.unshift(deviceObj);
              let currentAreaList = item.groupList.filter((i) => {
                if (i.code) {
                  return i;
                }
              });
              let currentDeviceList = item.groupList.filter((i) => {
                if (i.funList) {
                  return i;
                }
              });

              // 区域、设备名称排序-按字符串排序
              currentAreaList = currentAreaList.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              currentDeviceList = currentDeviceList.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              item.groupList = currentDeviceList.concat(currentAreaList);
              // devList是设备的最终来源

              if (!item.devList) {
                item.devList = [];
              }
              item.devList.push(deviceObj);
            }
          } else if (this.deviceType === 1) {
            // 编辑
            item.deviceType = this.addForm.deviceType;
            item.productType = this.addForm.productType;
            item.funList = this.addForm.funList;
            item.name = this.addForm.name;
            item.netInfoDTO = JSON.parse(JSON.stringify(this.netForm));
            item.sipInfoDTOList = this.putSipForm2();

            this.$emit("updateMsg", item);
          }

          // 添加成功，关闭弹窗
          this.spinShow = false;
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrData(item[child], id, idStr, child, name);
        }
      }
    },
    // 判断sip2是否加入配置中
    putSipForm2() {
      let sipInfoDTOList = [JSON.parse(JSON.stringify(this.sipForm1))];
      if (this.isExpandSip2) {
        sipInfoDTOList.push(JSON.parse(JSON.stringify(this.sipForm2)));
      }

      return sipInfoDTOList;
    },
    // 设置设备型号与功能选择匹配
    setFunList(val) {
      switch (val) {
        case "0":
          this.addForm.funList = [];
          break;
        case "SI701":
          this.addForm.funList = [0, 1, 3];
          break;
        case "SO801":
          this.addForm.funList = [1, 2, 3, 5];
          break;
        case "SO001":
          this.addForm.funList = [1, 2, 3, 5];
          break;
        case "SIA01":
          this.addForm.funList = [0, 1];
          break;
        default:
          break;
      }
    },
    // 全局下所有设备节点10000个的限制
    checkAllDeviceNum(maxNum = 10000) {
      let isNext = true;
      // 判断区域是否超出上限
      if (this.allDeviceNum + 1 > maxNum) {
        this.$Message.error(this.$t("updateNewSip.devMax"));
        isNext = false;
      }
      return isNext;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/projectConfig.scss";

.flex-box1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
}

.margin-box {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
